<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            {{ userStore.user.dob }}
            <br />
            {{ userStore.user.ssn }}
        </p>
        <p>
            {{ date }} <br />
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}, {{ address.zipcode }}
        </p>
        <p class="letter-content">
            <b>Subject:</b> Dispute and Verification of Collection/Charge-off Account on My Consumer File
        </p>
        <p class="letter-content">
            To whom it may concern,
        </p>
        <p class="letter-content">
            I am writing to formally dispute and request verification for a collection or charge-off account
            <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
                Account Number: {{ creditor.account_number }}, Creditor Name: {{ creditor.furnisher_name }},
            </p>
            <b>that is currently being reported on my credit report (Reference Number: {{ reportStore.reports[userStore.user.email].report.slug }}).</b>
            I have reason to believe this account does not belong to me or has been inaccurately reported.
        </p>
        <p class="letter-content">
            Pursuant to the <b>Fair Credit Reporting Act (FCRA), 15 U.S.C. § 1681i</b> and the right to accuracy and
            verification of debts under <b>15 U.S.C. § 1681s-2(a),</b> I kindly demand that you provide me with the
            original contract containing my wet ink signature which will validate and verify the debt allegedly belongs to me
        </p>
        <p class="letter-content">
            Specifically, in accordance with these regulations, I request the following:
            <ul>
                <li>The original contract or agreement with my wet ink signature.</li>
                <li>A detailed account history, including any and all payments made.</li>
                <li>The license numbers and state registrations of the collection agency to ensure its legality to collect a debt in my state.</li>
                <li>Documentation that verifies the amount you are reporting.</li>
            </ul>
        </p>
        <p class="letter-content">
            If you cannot provide these documents or if the alleged debt cannot be verified, then reporting it would be a direct violation of the FCRA. Hence, in such a scenario, you would be obligated to promptly delete this account from my credit report.
        </p>
        <p class="letter-content">
            It is crucial to note that if you continue reporting invalidated or unverified information, it can be seen as willful non-compliance with the FCRA, which could result in statutory and actual damages. I urge you to treat this request with the gravity and urgency it necessitates.
        </p>
        <p class="letter-content">
            Kindly initiate an investigation into this matter immediately. Please be aware that according to the FCRA, you are required to conduct this investigation within 30 days of receiving this letter. I
            expect to be provided with the results of this investigation and a revised copy of my credit report should any changes be made.
        </p>
        <p class="letter-content">
            Protecting the accuracy and fairness of credit reporting is not just a statutory mandate but also essential to ensure consumer trust and fairness in credit markets. I trust that you will do the
            right thing and address this matter with the urgency and seriousness it warrants
        </p>
        <p class="letter-content">
            Thank you for your immediate attention to this issue. I await your prompt response.
        </p>
        <p style="page-break-after: always;">
            Sincerely, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
